import {
  Sidebar,
  SidebarDivider,
  SidebarGroup,
  SidebarItem,
  SidebarSpace,
  SidebarSubmenu,
  SidebarSubmenuItem
} from '@backstage/core-components';
import { NavContentBlueprint } from '@backstage/plugin-app-react';
import type { ExtensionDefinition } from '@backstage/frontend-plugin-api';
import { SidebarLogo } from './SidebarLogo';
import MenuIcon from '@material-ui/icons/Menu';
import SearchIcon from '@material-ui/icons/Search';
import HomeIcon from '@material-ui/icons/Home';
import { SidebarSearchModal } from '@backstage/plugin-search';
import { UserSettingsSignInAvatar } from '@backstage/plugin-user-settings';
import { NotificationsSidebarItem } from '@backstage/plugin-notifications';
import CustomerIcon from '@material-ui/icons/SupervisorAccount';
import EnvironmentIcon from '@material-ui/icons/AccountTree';
import TemplatesIcon from '@material-ui/icons/Collections';
import SystemIcon from '@material-ui/icons/Category';
import ComponentIcon from '@material-ui/icons/Memory';
import ApiIcon from '@material-ui/icons/Extension';
import ExtensionIcon from '@material-ui/icons/Extension';
import GroupIcon from '@material-ui/icons/People';
import UserIcon from '@material-ui/icons/Person';
import MenuBook from '@material-ui/icons/MenuBook';
import Policy from '@material-ui/icons/Policy';
import BuildIcon from '@material-ui/icons/Build';
import { CertInventorySidebarItem } from '@internal/plugin-cert-inventory';

export const SidebarContent: ExtensionDefinition = NavContentBlueprint.make({
  params: {
    component: ({ navItems }) => {
      const nav = navItems.withComponent(item => (
        <SidebarItem icon={() => item.icon} to={item.href} text={item.title} />
      ));

      // Skipped items
      nav.take('page:search'); // Using search modal instead

      return (
        <Sidebar>
          <SidebarLogo />
          <SidebarGroup label="Search" icon={<SearchIcon />} to="/search">
            <SidebarSearchModal />
          </SidebarGroup>
          <SidebarDivider />
          <SidebarGroup label="Menu" icon={<MenuIcon />}>
            <SidebarItem icon={HomeIcon} text="Catalog">
              <SidebarSubmenu title="Catalog">
                <SidebarSubmenuItem title="Customers"
                  to="/?filters[kind]=customer"
                  icon={CustomerIcon} />
                <SidebarSubmenuItem title="Environments"
                  to="/?filters[kind]=environment"
                  icon={EnvironmentIcon} />
                <SidebarSubmenuItem title="Systems"
                  to="/?filters[kind]=system"
                  icon={SystemIcon} />
                <SidebarSubmenuItem title="Services"
                  to="/?filters[kind]=component&filters[type]=service"
                  icon={ComponentIcon} />
                <SidebarSubmenuItem title="Websites"
                  to="/?filters[kind]=component&filters[type]=website"
                  icon={ComponentIcon} />
                <SidebarSubmenuItem title="APIs"
                  to="/?filters[kind]=api"
                  icon={ApiIcon} />
                <SidebarDivider />
                <SidebarSubmenuItem title="Groups"
                  to="/?filters[kind]=group"
                  icon={GroupIcon} />
                <SidebarSubmenuItem title="Users"
                  to="/?filters[kind]=user"
                  icon={UserIcon} />
                <SidebarDivider />
                <SidebarSubmenuItem title="Templates"
                  to="/?filters[kind]=template"
                    icon={TemplatesIcon} />
              </SidebarSubmenu>
            </SidebarItem>
            {nav.take('page:techdocs')}
            {nav.take('page:scaffolder')}
            <SidebarDivider />
            <SidebarItem icon={ExtensionIcon} to="external-entity-integration" text="External Integrations" />
            <SidebarItem icon={MenuBook} to="catalog/default/component/saas-innovation-adrs/adrs" text="SaaS Inv. ADRs" />
            <SidebarItem icon={Policy} to="data-classification" text="Data Classification" />
            <SidebarItem icon={BuildIcon} to="tools" text="Tools" />
            <CertInventorySidebarItem />
          </SidebarGroup>
          <SidebarSpace />
          <SidebarDivider />
          <NotificationsSidebarItem />
          <SidebarDivider />
          <SidebarGroup
            label="Settings"
            icon={<UserSettingsSignInAvatar />}
            to="/settings"
          >
            {nav.take('page:app-visualizer')}
            {nav.take('page:user-settings')}
          </SidebarGroup>
        </Sidebar>
      );
    },
  },
});
